module.exports = __webpack_public_path__ + "static/media/play-background-1.c1554e66.mp3";